import Swiper from 'swiper/bundle';

export default function blockGallerySlider() {
    document.querySelectorAll('.gallery:not(.gallery--disabled)').forEach(function (slider) {
        const swiper = new Swiper(slider, {
            slidesPerView: "auto",
            spaceBetween: 18,
            speed: 1000,
            loop: true,
            observer: true,
            observeParents: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: slider.querySelector('.gallery__arrow--next'),
            },
        });
    });
}